export default __webpack_public_path__ + "static/media/range1.b3991441.jpeg";